import { render, staticRenderFns } from "./day-of-week.vue?vue&type=template&id=0d2f0fa7&"
import script from "./day-of-week.vue?vue&type=script&lang=js&"
export * from "./day-of-week.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports